module.exports = __webpack_public_path__ + "img/logoAR.4bffb45c.png";